// Dependencies
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import sha256 from 'crypto-js/sha256';

@Injectable({
  providedIn: 'root',
})
export class SendFormContactService {
  constructor(private http: HttpClient, private cookieService: CookieService) { }

  sendIntegrationAPI(
    event_name: string = 'API Contacto Exitoso',
    uniqueEventId?: string,
    pixel_id: string = `${environment.META_PIXEL_ID}`,
    token: string = `${environment.META_API_TOKEN}`
  ) {

    const userEmail: string = localStorage.getItem('user_email') || '';
    const userPhoneNumber: string = localStorage.getItem('user_phone') || '';
    const userName: string = localStorage.getItem('user_name') || '';
    const userSecondNames: string = localStorage.getItem('user_secondNames') || '';
    const userState: string = localStorage.getItem('user_state') || '';
    const userCity: string = localStorage.getItem('user_city') || '';
    const userPostalCode: string = localStorage.getItem('user_postalCode') || '';
    const userBirthday: string = localStorage.getItem('user_birthDay') || '';
    const _fbp: string = this.cookieService.get('_fbp') || '';

    const response = this.http.post(
      `https://graph.facebook.com/v18.0/${pixel_id}/events?access_token=${token}`,
      {
        data: [
          {
            event_name,
            event_time: Math.floor(Date.now() / 1000),
            action_source: 'website',
            ...(uniqueEventId ? { event_id: uniqueEventId } : {}),
            "user_data": {
              "em": [sha256(userEmail.trim().toLowerCase()).toString()],
              "ph": [sha256(userPhoneNumber.replace(/\D/g, '')).toString()],
              "fn": [sha256(userName.trim().toLowerCase()).toString()],
              "ln": [sha256(userSecondNames.trim().toLowerCase()).toString()],
              "st": [sha256(userState.trim().toLowerCase()).toString()],
              "ct": [sha256(userCity.trim().toLowerCase()).toString()],
              "zp": [sha256(userPostalCode.trim()).toString()],
              "db": [sha256(userBirthday.replace(/-/g, '')).toString()],
              "fbp": _fbp
            }
          },
        ],
      }
    );

    return response;
  }
}
